import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import DropdownProfile from "../components/DropdownProfile";

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    // Check if user is logged in
    if (userInfo) {
      // User is logged in, can add additional logic here if needed
    }
  }, [userInfo]);

  return (
    <header className="sticky top-0 z-999 flex w-full bg-white shadow-sm dark:bg-boxdark">
      <div className="flex flex-grow items-center justify-between py-3 px-4 md:px-6 2xl:px-11">
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          {/* <!-- Hamburger Toggle BTN --> */}
          <button
            aria-controls="sidebar"
            onClick={(e) => {
              e.stopPropagation();
              setSidebarOpen(!sidebarOpen);
            }}
            className="z-99999 block rounded-lg bg-primary bg-opacity-10 p-1.5 text-primary transition-all duration-200 hover:bg-opacity-20 lg:hidden"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          {/* <!-- Hamburger Toggle BTN --> */}
          <Link className="block flex-shrink-0 lg:hidden" to="/dashboard">
            <div className="text-primary font-bold text-xl flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.96 10.25c-1.42 1.92-2.12 2.88-2.7 2.88-.58 0-1.28-.96-2.7-2.88-1.42-1.92-2.12-2.88-1.64-3.84.48-.96 1.94-.96 4.34-.96 2.4 0 3.86 0 4.34.96.48.96-.22 1.92-1.64 3.84z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Express Halal Food
            </div>
          </Link>
        </div>

        {/* Search Bar */}
        <div className="hidden md:block flex-grow max-w-md mx-4">
          {/* <div className="relative">
            <input
              type="text"
              placeholder="Search..."
              className="w-full py-2 pl-10 pr-4 text-sm text-gray-700 bg-gray-100 rounded-lg focus:outline-none focus:bg-white focus:ring-1 focus:ring-primary transition-all duration-200"
            />
            <div className="absolute inset-y-0 left-0 flex items-center pl-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div> */}
        </div>

        <div className="flex items-center gap-3 2xsm:gap-7">
          {/* Notification Button */}
          {/* <button className="relative p-2 text-gray-500 hover:text-primary rounded-full hover:bg-gray-100 transition-all duration-200">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-danger"></span>
          </button> */}

          {/* User Profile */}
          <div className="flex items-center gap-3">
            <DropdownProfile />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
